import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { Button } from 'app/agriculture/components/Button/Button';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { useTasksForEntity } from 'app/agriculture/infobox/tasks/TasksForEntity/useTasksForEntity';
import { useMemo } from 'react';

interface TasksForEntityProps {
    assetId: string;
}

export function TasksForEntity({ assetId }: TasksForEntityProps) {
    const routeActions = useRouteActions();
    const tasks = useTasksForEntity(assetId);
    const activeTasks = useMemo(() => tasks.filter(({ isComplete }) => !isComplete), [tasks]);

    return (
        <StatDisplay
            name="Active Tasks"
            value={
                <Button
                    variant="compact"
                    text={activeTasks.length}
                    endIcon="goto"
                    onClick={() => {
                        routeActions.openList('Task');
                    }}
                />
            }
        />
    );
}
